var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFourActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#38C3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 11,
    fill: "#38C3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5865 21H19.4705V19.296H20.5985V17.904H19.4705V12.42H17.0825L13.3745 18.588V19.296H17.5865V21ZM15.3185 17.904L17.6225 13.884V17.904H15.3185Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFourActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/four-active.e0d0e17e.svg";
export { ForwardRef as ReactComponent };